module.exports = __webpack_public_path__ + "media/customizations/mywilloway/logo-new-1eab57c6c51068e941cf93d2f621a26c.png";